/**
 * Tutorial guidato delle impostazioni SEO.
 *
 * Un preparativo solo: il riquadro del primo servizio, che il passo dedicato apre
 * per mostrarne i campi. `stopSeoTour` lo richiude a fine giro, e solo se ad aprirlo
 * e' stato il tutorial. Gli interruttori non si toccano: salvano subito.
 */
const SCOPE = '[data-tour-scope="setting-seo"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo servizio, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopSeoTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createSeoTourSteps() {
	return [
		{
			body: "Qui stanno i servizi che aiutano i prodotti a farsi trovare: l'analisi dei testi, la traduzione automatica e i cataloghi da mandare a Google, Bing e Facebook. Non cambiano il sito - lavorano su come il sito viene letto da fuori.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I servizi SEO',
		},
		{
			body: "Una riga per servizio, ognuno con il suo interruttore che salva subito. Analisi SEO accende il punteggio SEO nelle schede di prodotti, categorie e marche (spenta, il pannello non compare); Google Translate fa comparire il pulsante Traduci accanto ai testi; DataForSEO o Google Ads (Keyword Planner, gratuito ma con il tuo account Google Ads) aggiungono all'Analisi SEO le idee per la parola chiave con il volume di ricerca: se ne accende uno solo alla volta.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere un servizio',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione di quel servizio. Per i merchant center - Google, Bing, Facebook - dentro il riquadro trovi anche l'indirizzo del feed dei prodotti, uno per lingua: e' quello da incollare nel pannello del servizio perche' vada a prendersi il catalogo da solo.",
			before: stopSeoTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: "Chiavi e identificativi si compilano con quello che il servizio ha rilasciato e si confermano qui dentro. Un feed puo' restare valido per mesi senza che nessuno lo guardi: quando i prodotti smettono di comparire su Google, e' il primo posto da controllare.",
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Credenziali e feed',
		},
	];
}
